const FADE_IN_UP_DELAY = 250;

window.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.animated');

  if (items.length) {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        async (entries, instance) => {
          // eslint-disable-next-line no-restricted-syntax
          for await (const entry of entries) {
            if (entry.isIntersecting) {
              await new Promise((resolve) => {
                let delay = 0;
                if (
                  entry.target.classList.contains('abc__fadein--up') ||
                  entry.target.classList.contains('abc__fadein--right')
                ) {
                  delay = FADE_IN_UP_DELAY;
                }

                entry.target.classList.add('visible');

                setTimeout(() => {
                  resolve(true);
                  instance.unobserve(entry.target);
                }, delay);
              });
            }
          }
        },
        { threshold: 0.1 },
      );

      Array.from(items).forEach((item) => observer.observe(item));
    } else {
      Array.from(items).forEach((item) => item.classList.add('visible'));
    }
  }
});

// Lottie loading
window.addEventListener('DOMContentLoaded', () => {
  const lottieImages = document.querySelectorAll('.ablottie');

  if (lottieImages.length) {
    import(/* webpackChunkName: "lottie" */ 'lottie-web').then((lottie) => {
      let lottieInstances = [];

      const initIntersectionObserver = () => {
        if ('IntersectionObserver' in window) {
          const lottieObserver = new IntersectionObserver(
            async (entries, instance) => {
              entries.forEach((selector) => {
                if (selector.isIntersecting) {
                  const { target } = selector;
                  const classNames = Array.from(target.classList);
                  const id = target.getAttribute('data-id');

                  if (!classNames.includes('played')) {
                    const lottieAnim = lottieInstances.find(
                      ({ id: dataId }) => dataId === id,
                    );

                    if (lottieAnim && !lottieAnim.playOnHover) {
                      lottieAnim.instance.play();
                      lottieAnim.instance.addEventListener('complete', () =>
                        target.classList.add('played'),
                      );
                    }

                    if (lottieAnim.playOnHover) {
                      lottieAnim.selector
                        .closest('.big-links__link')
                        .addEventListener('mouseover', () => {
                          lottieAnim.instance.setDirection(1);
                          lottieAnim.instance.play();
                        });

                      lottieAnim.selector
                        .closest('.big-links__link')
                        .addEventListener('mouseleave', () => {
                          lottieAnim.instance.setDirection(-1);
                          lottieAnim.instance.play();
                        });
                    }
                  }

                  instance.unobserve(target);
                }
              });
            },
            { threshold: 0.1 },
          );

          lottieInstances.forEach(({ selector }) =>
            lottieObserver.observe(selector),
          );
        }
      };

      const initLottie = (selector) => {
        const dataId = selector.getAttribute('data-id');
        const autoplay = selector.getAttribute('data-autoplay') === 'true';
        const loop = selector.getAttribute('data-loop') === 'true';
        const path = selector.getAttribute('data-url');
        const playOnHover =
          selector.getAttribute('data-playOnHover') === 'true';

        const instance = lottie.loadAnimation({
          container: selector,
          renderer: 'svg',
          loop,
          autoplay,
          path,
        });

        selector.classList.add('loaded');

        return {
          id: dataId,
          instance,
          selector,
          playOnHover,
        };
      };

      lottieInstances = Array.from(lottieImages).map((selector) =>
        initLottie(selector),
      );

      initIntersectionObserver();
    });
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('a[data-popup]');

  if (buttons.length) {
    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const { currentTarget } = e;

        const isCTA = currentTarget.classList.contains('abc__cta');

        const href = isCTA
          ? currentTarget.querySelector('a').href
          : currentTarget.href;

        const body = document.querySelector('body');

        if (href) {
          const popup = document.querySelector(
            isCTA
              ? href.replace(window.location.href, '')
              : `#${currentTarget.dataset.popup}`,
          );

          const overlay = popup.childNodes[0];

          overlay.addEventListener('click', () => {
            popup.classList.remove('active');
            body.style.overflow = 'auto';
          });

          if (popup) {
            body.style.overflow = 'hidden';
            popup.classList.add('active');
          }
        }
      });
    });
  }
});
